import { Component, Input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { CarDetailElectroStatsItemComponent } from './car-detail-electro-stats-item/car-detail-electro-stats-item.component';
import { ImageComponent } from '@atoms/image/image.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { DateFormatPipe } from '@pipes/date-format.pipe';
import { FloatNumberPipe } from '@pipes/float-number.pipe';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { CarItem } from '@models/car.model';

@Component({
  selector: 'app-car-detail-electro-stats',
  imports: [LowerCasePipe, TranslateModule, CarDetailElectroStatsItemComponent, ImageComponent, ParagraphComponent, DateFormatPipe, FloatNumberPipe, ThousandsPipe],
  templateUrl: './car-detail-electro-stats.component.html',
  styleUrl: './car-detail-electro-stats.component.scss',
})
export class CarDetailElectroStatsComponent {
  @Input() car?: CarItem;
}
